/* eslint-disable react-doctor/rendering-svg-precision */
import "@/components/shared/error-state-motion.css";

interface KitsSweatIllustrationProps {
    className?: string;
}

export function KitsSweatIllustration({
    className,
}: KitsSweatIllustrationProps) {
    return (
        <svg
            width="199"
            height="153"
            viewBox="0 0 199 153"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`w-[100px] h-[77px] overflow-hidden select-none ${className ?? ""}`}
            role="img"
            aria-label="Sweating dog illustration"
        >
            <path
                d="M177.988 75.9341L188.265 97.698L92.1412 147.271L80.6547 120.066L18.0834 93.8516C12.1299 81.2072 9.37166 69.9013 11.226 56.1338L43.4955 52.2912L71.6602 17.5549L103.804 10.7881L121.696 14.8316L135.522 20.9833L152.237 26.5619C197.24 35.5615 193.383 40.7047 167.667 56.1338L177.988 75.9341Z"
                fill="#DD671D"
            />
            <path
                d="M15.8195 55.5031C31.412 54.4574 61.4574 44.4849 85.7717 77.4469C110.017 110.316 101.411 113.146 102.941 117.094C102.947 117.103 102.951 117.115 102.955 117.127C102.95 117.116 102.946 117.105 102.941 117.094C102.436 116.178 93.5815 128.382 85.7206 123.769C73.5124 116.605 18.9921 100.234 15.6528 93.5895C14.2597 87.4259 -1.48544 68.0988 15.8195 55.5031Z"
                fill="#F5ECE2"
            />
            <path
                d="M136.81 21.4134C97.807 -2.16051 70.808 15.8027 59.7278 30.44C48.6476 45.0773 44.8607 49.9543 44.0669 51.1394L11.9395 56.2007C9.38283 64.8036 9.66153 91.1692 23.6571 97.2801C54.0881 110.567 82.2389 120.673 82.2389 120.673"
                stroke="#1F0E01"
                strokeWidth="6.72584"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5731 58.3358L31.4331 56.0867C28.9433 72.3294 15.7823 73.2583 9.51306 71.6924L14.5731 58.3358Z"
                fill="#1F0E01"
            />
            <path
                d="M168.094 55.2715L178.586 78.5202L186.953 96.4172"
                stroke="#1F0E01"
                strokeWidth="6.72584"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.246 72.9102L82.4721 121.274C82.4721 121.274 77.878 128.529 82.4721 138.806C85.9851 146.666 92.1449 149.084 92.1449 149.084L194.919 97.0923L185.246 72.9102Z"
                fill="#75290F"
                stroke="#1F0E01"
                strokeWidth="6.72584"
                strokeLinejoin="round"
            />
            <path
                className="kits-sweat-ear"
                d="M131.31 38.1753C128.599 44.0051 130.707 56.0551 145.409 59.2898C160.111 62.5246 176.411 50.1539 190.249 39.301L138.502 22.1451"
                stroke="#1F0E01"
                strokeWidth="6.75475"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="63.1493" cy="46.4351" r="5.63542" fill="#1F0E01" />
            <circle cx="78.579" cy="51.1499" r="5.63542" fill="#1F0E01" />
            <g className="kits-sweat-drop">
                <path
                    d="M114.861 38.572C114.861 32.4001 108.861 25.1425 105.861 22.2852C102.861 25.4282 96.8599 33.0859 96.8599 38.572C96.8599 45.4296 101.146 49.287 105.861 49.287C110.577 49.287 114.861 46.2868 114.861 38.572Z"
                    fill="#A4C6EA"
                    stroke="#1F0E01"
                    strokeWidth="6.75475"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M67.0589 80.6088C67.4445 83.5075 66.1452 89.6319 57.8628 90.94"
                stroke="#1F0E01"
                strokeWidth="6.72416"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M65.9432 35.7943C69.9737 36.0107 71.1055 33.7529 71.1675 32.597C71.2373 31.2969 70.0593 29.7107 66.2807 29.5078C62.502 29.3049 59.4325 30.0101 59.3278 31.9614C59.223 33.9126 60.905 35.5238 65.9432 35.7943Z"
                fill="#FFFBF7"
            />
            <path
                d="M82.4508 31.7062C78.5048 30.4049 76.7346 32.4561 76.3428 33.6444C75.902 34.9809 76.6204 36.9486 80.3198 38.1686C84.0192 39.3885 87.2728 39.4727 87.9342 37.4669C88.5957 35.461 87.3834 33.3328 82.4508 31.7062Z"
                fill="#FFFBF7"
            />
        </svg>
    );
}
